
import React from 'react';
import { branch, renderComponent } from 'recompose';
import { Loader, Dimmer } from 'semantic-ui-react';


export const withReadyLoader = branch(
  ({ ready }) => !ready,
  renderComponent(() => <Dimmer active><Loader content='Loading' /></Dimmer>)
);
